module.exports = __webpack_public_path__ + "static/media/MalcolmReynolds.332fe6d0.jpg";